import { useCallback } from 'react';

import { useExport } from '@/features/DataHub/modules/Export/context/ExportContext';
import type { ExportSettingsType } from '@/features/DataHub/modules/Export/types';

export const useExportSettingsActions = () => {
  const { exportSettings, setExportSettings } = useExport();

  const updateExportSetting = useCallback(
    <K extends keyof ExportSettingsType>(key: K, value: ExportSettingsType[K]) => {
      setExportSettings(prev => ({ ...prev, [key]: value }));
    },
    [setExportSettings]
  );

  return { exportSettings, updateExportSetting, setExportSettings };
};
